import { Modal, Radio } from "antd";
import { RadioChangeEvent } from "antd/lib/radio";
import React, { FC, useState } from "react";

interface IProps {
	openActivateModal: boolean;
	closeActivateModal?: () => void;
	onSave: (active: boolean) => void;
}

const ActivateUsersModal: FC<IProps> = ({
	openActivateModal,
	closeActivateModal,
	onSave,
}) => {
	const [active, setActive] = useState<boolean>();
	const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

	const onActivateChanged = (e: RadioChangeEvent) => {
		setButtonDisabled(false);
		setActive(e.target.value);
	};

	const onHandleSave = () => {
		setButtonDisabled(true);
		onSave(active!);
	};

	return (
		<Modal
			visible={openActivateModal}
			title="Activate or Inactivate the Selected Users"
			onCancel={closeActivateModal}
			okText="Save"
			width={420}
			onOk={onHandleSave}
			okButtonProps={{
				disabled: buttonDisabled,
			}}
		>
			<div className="row d-flex justify-content-around">
				<Radio.Group
					name="Activate"
					onChange={onActivateChanged}
					value={active}
				>
					<Radio key={`Active`} value={true}>
						Activate
					</Radio>
					<Radio key={`Inactive`} value={false}>
						Inactivate
					</Radio>
				</Radio.Group>
			</div>
		</Modal>
	);
};

export default ActivateUsersModal;
